const productData = [
  {
    id: 1,
    name: "Woven Tailored Barrel Sleeve Wrap Blazer",
    category: "Blazers",
    price: "115.00",
    reviews: "342",
    rating: "4.6",
    image: "/img/101.webp",
    images: ["/img/101.webp" ],
    size: ["XS", "S", "M", "L", "XL"],
    colors: ["Warm White", "Natural Black", "Cream"],
    material: "Wool Blend & Recycled Materials",
    description: [
      "A sculpted woven blazer with barrel sleeves and a wrap front that flatters the waist.",
      "Structured yet soft wool-blend fabric offers comfortable all-day wear and keeps shape.",
      "Ideal for office-to-evening styling — pairs with tailored trousers or dresses.",
      "Sustainably blended fibers reduce environmental impact without sacrificing quality.",
      "Tailored construction with a smooth lining for comfortable layering.",
      "Designed to be a versatile wardrobe investment for multiple seasons.",
    ],
    Features: [
      "Wrap front with internal and external fastenings",
      "Barrel sleeve detail for a modern silhouette",
      "Fully lined for easy layering",
      "Wool blend with recycled content",
      "Tailored seams and reinforced stitching",
      "Available in core seasonal colours",
      "Dry clean or gentle machine wash — see care label",
      "Versatile piece for work and eveningwear",
    ],
  },
  {
    id: 2,
    name: "Woven Tailored Slim Straight Leg Trousers",
    category: "Trousers",
    price: "140.00",
    reviews: "289",
    rating: "4.7",
    image: "/img/102.webp",
    images: ["/img/102.webp" ],
    size: ["XS", "S", "M", "L", "XL"],
    colors: ["Deep Red", "Charcoal", "Navy", "Black"],
    material: "Wool Blend & Tailored Fabric",
    description: [
      "Slim straight-leg trousers crafted from a premium woven blend for a polished finish.",
      "Designed to sit comfortably at the natural waist and elongate the silhouette.",
      "Durable fabric resists creasing, keeping you looking sharp through the day.",
      "Perfect for tailored outfits or to soften with knitwear for a casual look.",
      "Finished with pressed creases and a neat hem for professional styling.",
    ],
    Features: [
      "Mid-rise waistband with secure fastening",
      "Slim straight leg with pressed crease",
      "Side pockets and back welt pocket",
      "Woven fabric with slight stretch for comfort",
      "Professional tailoring details and seams",
      "Available in multiple colours and sizes",
      "Easy to pair with blazers or knitwear",
      "Machine washable on gentle cycle (see care label)",
    ],
  },
  {
    id: 3,
    name: "Patent Faux Leather Oversized Bomber Jacket",
    category: "Jackets",
    price: "130.00",
    reviews: "214",
    rating: "4.5",
    image: "/img/103.webp",
    images: ["/img/103.webp" ],
    size: ["XS", "S", "M", "L", "XL"],
    colors: ["Olive", "Mulberry", "Black"],
    material: "Patent Faux Leather",
    description: [
      "Oversized bomber jacket finished in glossy patent faux leather for a statement outerwear piece.",
      "Relaxed silhouette makes it perfect for layering over hoodies and chunky knits.",
      "Ribbed trims keep the classic bomber shape while providing comfort and fit.",
      "Shiny exterior is easy to wipe clean and makes a bold wardrobe accent.",
      "A contemporary take on a heritage shape — ideal for street-style looks.",
    ],
    Features: [
      "Patent faux leather exterior",
      "Oversized bomber cut with ribbed cuffs and collar",
      "Front zip closure with storm placket",
      "Functional pockets and lining",
      "Easy-care finish for every season",
      "Available in seasonal colourways",
      "Durable hardware and reinforced seams",
      "Layer-friendly roomy fit",
    ],
  },
  {
    id: 4,
    name: "Striped Open Collar Top",
    category: "Tops",
    price: "125.00",
    reviews: "178",
    rating: "4.6",
    image: "/img/104.webp",
    images: ["/img/104.webp" ],
    size: ["XS", "S", "M", "L", "XL"],
    colors: ["Mulberry", "Tan", "White", "Navy"],
    material: "Cotton Blend",
    description: [
      "Casual striped open collar top with a relaxed fit and breathable cotton blend fabric.",
      "Short sleeves and a lightweight construction make it perfect for layering or warm days.",
      "Classic stripes provide a timeless, nautical-inspired aesthetic.",
      "Easy to style tucked into jeans or layered under jackets for transitional weather.",
      "Low-maintenance fabric that's comfortable for everyday wear.",
    ],
    Features: [
      "Open collar with short sleeve silhouette",
      "Soft cotton blend fabric",
      "Classic horizontal stripe pattern",
      "Lightweight and breathable",
      "Easy-care wash instructions",
      "Designed for relaxed, everyday wear",
      "Available in core seasonal shades",
      "Versatile styling options",
    ],
  },
  {
    id: 5,
    name: "Single Breasted Relaxed Fit Tailored Blazer",
    category: "Blazers",
    price: "120.00",
    reviews: "305",
    rating: "4.8",
    image: "/img/105.webp",
    images: ["/img/105.webp" ],
    size: ["XS", "S", "M", "L", "XL"],
    colors: ["Neutral", "Gold", "Black", "Navy"],
    material: "Wool Blend",
    description: [
      "Single-breasted relaxed-fit blazer crafted from a soft wool blend for elevated everyday tailoring.",
      "Relaxed shoulders and a longline cut offer a modern silhouette that layers easily.",
      "Minimalist design with functional pockets and a clean lapel.",
      "A versatile blazer that moves from office to weekend with ease.",
      "Durable, structured fabric keeps its shape wash after wash.",
    ],
    Features: [
      "Single-breasted closure",
      "Relaxed tailored fit with notch lapel",
      "Functional pockets and full lining",
      "Soft wool blend fabric",
      "Durable stitching and construction",
      "Available in versatile neutrals",
      "Easy to dress up or down",
      "Care instructions on label",
    ],
  },
  {
    id: 6,
    name: "Stripe Rugby Top",
    category: "Tops",
    price: "95.00",
    reviews: "198",
    rating: "4.4",
    image: "/img/106.webp",
    images: ["/img/106.webp"],
    size: ["XS", "S", "M", "L", "XL"],
    colors: ["Plum Blur", "Beige", "Navy", "White"],
    material: "Cotton Rugby Fabric",
    description: [
      "Classic rugby top with bold stripes and a structured collar for sporty styling.",
      "Made from durable mid-weight cotton that holds its shape and washes well.",
      "Relaxed fit with ribbed cuffs for that authentic rugby feel.",
      "A timeless casual staple that pairs well with denim and joggers.",
    ],
    Features: [
      "Traditional rugby collar and placket",
      "Ribbed cuffs and hem",
      "Mid-weight cotton construction",
      "Bold stripe pattern",
      "Durable and easy-care",
      "Available in multiple colour options",
      "Comfortable relaxed silhouette",
      "Great for layering",
    ],
  },
  {
    id: 7,
    name: "Faux Suede Buckle Trim Baguette Shoulder Bag",
    category: "Bags",
    price: "135.00",
    reviews: "240",
    rating: "4.7",
    image: "/img/107.webp",
    images: ["/img/107.webp" ],
    size: ["One Size"],
    colors: ["Mocha", "Heather", "Black", "Tan"],
    material: "Faux Suede",
    description: [
      "Elegant baguette shoulder bag in faux suede with a decorative buckle trim.",
      "Compact silhouette designed to carry essentials in style.",
      "Luxurious-looking hardware and adjustable strap for versatile wear.",
      "Perfect for elevating both day and evening looks.",
      "Durable lining and internal pocket for organised storage.",
    ],
    Features: [
      "Faux suede exterior with soft texture",
      "Gold-tone buckle trim",
      "Adjustable shoulder strap",
      "Interior pocket for small essentials",
      "Compact baguette shape for sleek styling",
      "Durable lining and hardware",
      "Available in seasonal colours",
      "Easy to pair with tailored or casual outfits",
    ],
  },
  {
    id: 8,
    name: "Snap Clutch Bag",
    category: "Bags",
    price: "150.00",
    reviews: "190",
    rating: "4.8",
    image: "/img/108.webp",
    images: ["/img/108.webp" ],
    size: ["One Size"],
    colors: ["Brown", "Olive", "Black", "Gold"],
    material: "Faux Leather & Metallic Accents",
    description: [
      "Structured snap clutch in premium faux leather finished with metallic accents.",
      "Compact and elegant — designed for evening events and smart daytime use.",
      "Interior card slots and a secure snap closure keep your essentials organised.",
      "Detachable chain strap allows the bag to convert from clutch to shoulder wear.",
    ],
    Features: [
      "Magnetic/snap closure",
      "Interior organisation pockets",
      "Detachable chain strap",
      "Faux leather with metallic trim",
      "Compact structured silhouette",
      "Lightweight and durable",
      "Available in classic finishes",
      "Suitable for evening and formal styling",
    ],
  },
  {
    id: 9,
    name: "High Waist Crossover Waistband Wide Leg Jean",
    category: "Jeans",
    price: "145.00",
    reviews: "256",
    rating: "4.7",
    image: "/img/109.webp",
    images: ["/img/109.webp" ],
    size: ["24", "25", "26", "27", "28", "29", "30", "31", "32"],
    colors: ["Trail Green", "Stone", "Indigo", "Light Wash"],
    material: "Denim Cotton Blend",
    description: [
      "High-waist wide-leg jeans featuring a crossover waistband for a flattering fit.",
      "Premium denim that softens with wear and offers comfortable movement.",
      "Wide leg silhouette creates a relaxed, fashion-forward look.",
      "Classic five-pocket styling with durable hardware.",
    ],
    Features: [
      "Crossover waistband detail",
      "Wide leg denim silhouette",
      "Premium cotton blend with subtle stretch",
      "Five-pocket construction",
      "Available in multiple washes and sizes",
      "Durable seams and hardwear",
      "Easy to dress up or down",
      "Machine washable",
    ],
  },
  {
    id: 10,
    name: "Boxy Zip Through Hoodie And Barrel Leg Jogger Tracksuit",
    category: "Tracksuits",
    price: "130.00",
    reviews: "312",
    rating: "4.9",
    image: "/img/1010.webp",
    images: ["/img/1010.webp" ],
    size: ["XS", "S", "M", "L", "XL"],
    colors: ["Black", "Charcoal", "Grey", "Navy"],
    material: "Cotton Blend & Fleece",
    description: [
      "Coordinated tracksuit with a boxy zip-through hoodie and matching barrel-leg joggers.",
      "Soft fleece interior feels cosy while the exterior keeps a clean finish.",
      "Boxy hoodie offers a relaxed, contemporary profile; joggers finish with elastic cuffs.",
      "A versatile set for lounging, travel or casual streetwear outfits.",
    ],
    Features: [
      "Full-zip hoodie with kangaroo pocket",
      "Barrel-leg joggers with elasticated cuff",
      "Brushed fleece interior",
      "Drawcord waist for adjustable fit",
      "Durable cotton-blend fabric",
      "Available in coordinated colourways",
      "Machine washable and easy care",
      "Comfort-first design",
    ],
  },
  {
    id: 11,
    name: "Faux Suede Tote Bag",
    category: "Bags",
    price: "120.00",
    reviews: "198",
    rating: "4.6",
    image: "/img/1011.webp",
    images: ["/img/1011.webp" ],
    size: ["One Size"],
    colors: ["Charcoal", "Rose", "Black", "Cream"],
    material: "Faux Suede",
    description: [
      "Spacious faux suede tote that combines premium texture with daily practicality.",
      "Large interior fits a laptop, documents and essentials for work or travel.",
      "Soft yet durable faux suede provides a refined finish at an accessible price.",
      "Comfortable handles and internal pocket keep items secure and organised.",
    ],
    Features: [
      "Spacious interior capacity",
      "Soft faux suede exterior",
      "Interior pocket for small items",
      "Reinforced handles for durability",
      "Versatile styling for work or leisure",
      "Available in key seasonal colours",
      "Easy to clean surface",
      "Long-lasting construction",
    ],
  },
  {
    id: 12,
    name: "Barrel Leg Trouser",
    category: "Trousers",
    price: "115.00",
    reviews: "267",
    rating: "4.5",
    image: "/img/1012.webp",
    images: ["/img/1012.webp" ],
    size: ["XS", "S", "M", "L", "XL"],
    colors: ["Gunmetal", "Blush", "Black", "Navy"],
    material: "Tailored Fabric Blend",
    description: [
      "Contemporary barrel-leg trousers with a mid-rise waist and tailored detailing.",
      "Elegant drape and front crease give a polished finish for office wear.",
      "Functional pockets and durable stitching for daily use.",
      "Flexible fabric blend ensures comfort and movement.",
    ],
    Features: [
      "Barrel leg cut",
      "Mid-rise waistband",
      "Front crease for polished look",
      "Functional pockets",
      "Tailored fabric with stretch",
      "Quality sewing and finishing",
      "Available in versatile shades",
      "Machine washable",
    ],
  },
  {
    id: 13,
    name: "Cinched Waist Half Sleeve T-Shirt",
    category: "Tops",
    price: "125.00",
    reviews: "223",
    rating: "4.6",
    image: "/img/1013.webp",
    images: ["/img/1013.webp" ],
    size: ["XS", "S", "M", "L", "XL"],
    colors: ["Taupe", "Stone", "White", "Black"],
    material: "Cotton Blend Jersey",
    description: [
      "Flattering half-sleeve tee with cinched waist detail to create shape without restricting movement.",
      "Soft cotton-jersey construction makes it breathable and comfortable for everyday wear.",
      "Perfect for layering or styling solo with high-rise bottoms.",
      "Durable finish that retains shape after washing.",
    ],
    Features: [
      "Cinched waistline detail",
      "Crew neck and half-sleeve structure",
      "Soft cotton-blend fabric",
      "Breathable and comfortable for all-day wear",
      "Available in staple colours",
      "Durable stitching",
      "Easy to style across casual and smart looks",
      "Care label recommended washing",
    ],
  },
  {
    id: 14,
    name: "Wide Leg Cargo Jogger",
    category: "Trousers",
    price: "130.00",
    reviews: "198",
    rating: "4.7",
    image: "/img/1014.webp",
    images: ["/img/1014.webp" ],
    size: ["XS", "S", "M", "L", "XL"],
    colors: ["Cognac Swirl", "Black", "Olive", "Grey"],
    material: "Cotton Blend with Cargo Pockets",
    description: [
      "Wide-leg cargo joggers combining utility pockets with relaxed contemporary styling.",
      "Drawcord waist and elastic cuffs provide an adjustable, secure fit.",
      "Soft cotton-blend fabric ensures comfort with an on-trend silhouette.",
      "Practical for travel and everyday wear while retaining fashion-forward details.",
    ],
    Features: [
      "Multiple cargo pockets for utility",
      "Drawcord waist with elasticated finish",
      "Wide leg silhouette for relaxed fit",
      "Durable, easy-care fabric",
      "Reinforced stitching on stress points",
      "Available in seasonal colours",
      "Comfort-focused design",
      "Machine washable",
    ],
  },
  {
    id: 15,
    name: "Denim Tote Bag",
    category: "Bags",
    price: "150.00",
    reviews: "312",
    rating: "4.8",
    image: "/img/1015.webp",
    images: ["/img/1015.webp" ],
    size: ["One Size"],
    colors: ["Leopard", "Ivory", "Indigo", "Light Wash"],
    material: "Denim Cotton Canvas",
    description: [
      "Durable denim tote bag inspired by classic workwear — roomy enough for everyday essentials.",
      "Reinforced topstitching and strong handles for confident carrying.",
      "Casual, wearable texture suitable for weekend and travel looks.",
      "Interior pocket helps keep smaller items organised.",
    ],
    Features: [
      "Denim canvas construction",
      "Spacious interior and reinforced handles",
      "Topstitch detailing for durability",
      "Interior pocket for small items",
      "Available in multiple washes",
      "Easy to pair with casual outfits",
      "Long-lasting and hardwearing",
      "Machine-washable accents where applicable",
    ],
  },
  {
    id: 16,
    name: "Stripe Rib Button Through Short Sleeve Top",
    category: "Tops",
    price: "120.00",
    reviews: "187",
    rating: "4.7",
    image: "/img/1016.webp",
    images: ["/img/1016.webp" ],
    size: ["XS", "S", "M", "L", "XL"],
    colors: ["Neutral", "Olive", "White", "Black"],
    material: "Ribbed Cotton Blend",
    description: [
      "Ribbed button-through top with a soft stretch fabric and classic stripe detailing.",
      "Comfortable and versatile — style it as a top layer or as a lightweight jacket alternative.",
      "Good for transitional climates and layering under coats.",
    ],
    Features: [
      "Ribbed textured fabric",
      "Button-through front for styling versatility",
      "Short sleeve and fitted body",
      "Breathable cotton blend",
      "Easy to layer and style",
      "Available in multiple colours",
      "Machine-wash friendly",
      "Durable knit construction",
    ],
  },
  {
    id: 17,
    name: "Single Breasted Oversized Blazer",
    category: "Blazers",
    price: "95.00",
    reviews: "234",
    rating: "4.6",
    image: "/img/1017.webp",
    images: ["/img/1017.webp" ],
    size: ["XS", "S", "M", "L", "XL"],
    colors: ["Midnight Blue", "White", "Black", "Grey"],
    material: "Tailored Wool Blend",
    description: [
      "A contemporary oversized blazer with relaxed proportions for modern tailoring.",
      "Soft wool-blend fabric gives body while remaining comfortable for all-day wear.",
      "Notch lapel and single-breasted closure create a timeless look with a relaxed edge.",
      "An accessible tailoring piece that pairs with denim or tailored bottoms.",
    ],
    Features: [
      "Oversized single-breasted silhouette",
      "Notch lapel and structured shoulder",
      "Fully lined with inner pocket",
      "Tailored wool-blend fabric",
      "Durable construction and quality finishing",
      "Suitable for work and smart-casual looks",
      "Available in seasonal neutrals",
      "Care instructions on label",
    ],
  },
  {
    id: 18,
    name: "Button Detail Tailored Wide Leg Trousers",
    category: "Trousers",
    price: "110.00",
    reviews: "201",
    rating: "4.6",
    image: "/img/1018.webp",
    images: ["/img/1018.webp" ],
    size: ["XS", "S", "M", "L", "XL"],
    colors: ["Mulberry", "Sand", "Black", "Navy"],
    material: "Tailored Fabric Blend",
    description: [
      "Tailored wide-leg trousers with elegant button details at the waistband.",
      "High-quality woven fabric ensures a refined drape and long-lasting wear.",
      "Functional pockets and a clean finish make this an office-ready favourite.",
    ],
    Features: [
      "Decorative button detailing",
      "Wide leg tailoring",
      "Quality woven fabric with structure",
      "Front and side pockets",
      "Mid-rise waist for comfort",
      "Pressed crease for a polished look",
      "Available in classic colours",
      "Professional styling versatility",
    ],
  },
  {
    id: 19,
    name: "Half Zip Sweatshirt Piping Detail Tracksuit",
    category: "Tracksuits",
    price: "135.00",
    reviews: "276",
    rating: "4.8",
    image: "/img/1019.webp",
    images: ["/img/1019.webp" ],
    size: ["XS", "S", "M", "L", "XL"],
    colors: ["Gunmetal", "Ivory", "Black", "Grey"],
    material: "Cotton Blend Fleece",
    description: [
      "Half-zip sweatshirt with contrast piping and matching jogger for a refined tracksuit look.",
      "Soft fleece lining for comfort while maintaining a clean, sporty silhouette.",
      "Perfect for relaxed days, travel or light exercise with elevated detailing.",
    ],
    Features: [
      "Half-zip front closure",
      "Contrast piping detail",
      "Brushed fleece interior",
      "Matching jogger with elastic cuffs",
      "Relaxed fit for comfort and movement",
      "Available in neutral shades",
      "Easy care fabric blend",
      "Durable stitching and finish",
    ],
  },
  {
    id: 20,
    name: "Ruched Tassel Loafers",
    category: "Shoes",
    price: "108.00",
    reviews: "189",
    rating: "4.6",
    image: "/img/1020.webp",
    images: ["/img/1020.webp" ],
    size: ["5", "6", "7", "8", "9", "10"],
    colors: ["Black with Gunmetal", "Blush", "Tan", "Navy"],
    material: "Velvet & Suede Blend",
    description: [
      "Elegant ruched loafers featuring soft velvet and detailed tassels for a luxe finish.",
      "Comfortable low block heel and cushioned insole for all-day wear.",
      "A versatile shoe that pairs with both tailored and casual looks.",
    ],
    Features: [
      "Velvet and suede upper accents",
      "Ruched vamp with tassel detail",
      "Low block heel for comfortable elevation",
      "Cushioned insole and lining",
      "Durable rubber sole",
      "Slip-on design with elastic goring for fit",
      "Available in seasonal colourways",
      "Sophisticated styling suitable for day and evening",
    ],
  },
];

export default productData;


